import { render } from "./WorkCassaField.vue?vue&type=template&id=8b1d3a02"
import script from "./WorkCassaField.vue?vue&type=script&lang=js"
export * from "./WorkCassaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__